
import { Component, Emit, Inject, Vue } from "vue-property-decorator";
import Modal from "../../../../common/src/components/Modal.vue";
import { Container } from "inversify";
import { ConferenceCreateStore } from "../../stores/conference/ConferenceCreateStore";
import ActionButton from "../../../../common/src/components/ActionButton.vue";
import ConferenceForm from "./ConferenceForm.vue";

@Component({
    components: { ConferenceForm, ActionButton, Modal },
})
export default class CreateEventModal extends Vue {
    @Inject("container") readonly container!: Container;
    createStore: ConferenceCreateStore = this.container.get(ConferenceCreateStore);
    logoFile: any = null;

    get values() {
        return this.createStore.data;
    }

    get errors() {
        return this.createStore.formErrors;
    }

    @Emit()
    submit() {
        //
    }

    @Emit()
    close() {
        //
    }

    async onSubmit() {
        this.createStore.logoFile.set("logo", this.logoFile);
        this.submit();
    }
}
